import { featuresItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-500/15 text-primary-400 border border-primary-500/20 mb-4">
            为什么选择我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-50">
            平台优势
          </h2>
          <p className="mt-3 text-sm text-foreground-400 max-w-lg mx-auto">
            五大核心优势，为你带来极致黑料视频观看体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featuresItems.map((item) => (
            <div
              key={item.id}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/50 text-center group hover:border-primary-500/30 transition-all duration-300"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-500/10 flex items-center justify-center group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-2xl text-primary-400`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-100 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}